import { render, staticRenderFns } from "./font-awesome.vue?vue&type=template&id=3e070fe3&scoped=true"
import script from "./font-awesome.vue?vue&type=script&lang=js"
export * from "./font-awesome.vue?vue&type=script&lang=js"
import style0 from "./font-awesome.vue?vue&type=style&index=0&id=3e070fe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e070fe3",
  null
  
)

export default component.exports